/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PlatformAssignedTasks {
    getFixupPrototypeFunction() { return PlatformAssignedTasks.fixupPrototype; }

    static newInstance(model: Partial<PlatformAssignedTasks>): PlatformAssignedTasks {
        let obj = Object.assign(new PlatformAssignedTasks(), model);
        PlatformAssignedTasks.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PlatformAssignedTasks>): PlatformAssignedTasks {
        if (!model) return null;
        return PlatformAssignedTasks.newInstance(<PlatformAssignedTasks> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PlatformAssignedTasks) {
        if (!obj) return;

        models.PlatformAssignedTasks.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PlatformAssignedTasks): boolean {
        Object.setPrototypeOf(obj, PlatformAssignedTasks.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.properties) {
            models.PlatformTaskProperties.fixupPrototype(this.properties);
        }
    }

    /**
     * Unique ID of the assigned task
     */
    task_id: string;

    /**
     * Assigned task
     */
    assigned_task: models.PlatformTasks;

    /**
     * Task specific properties (number of days for backfill)
     */
    properties: models.PlatformTaskProperties;

}
